import { render, staticRenderFns } from "./SideMenuDisplayer.vue?vue&type=template&id=12228dd6&scoped=true&"
import script from "./SideMenuDisplayer.vue?vue&type=script&lang=js&"
export * from "./SideMenuDisplayer.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuDisplayer.vue?vue&type=style&index=0&id=12228dd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12228dd6",
  null
  
)

export default component.exports